import ParamTypeMixin from '../ParamTypeMixin';
export default {
	mixins: [ParamTypeMixin],
	props: {
		listParamsMap: { type: Object },
		listParamsMapLabels: { type: Object },
	},
	computed: {
		paramsMap() {
			return this.listParamsMap;
		},
		paramsMapLabels() {
			return this.listParamsMapLabels;
		},
	},
};
